/* ZYNOX — Judge.me yorum seridine ok tuslari (baslik satirinda) */
(function () {
  function build(list) {
    if (!list || list.dataset.zxNav) return;
    var widget = list.closest('.jm-review-widget');
    // "Degerlendirme yazin" + filtre/siralama ikonlarinin bulundugu yatay kume
    var bar = widget && (
      widget.querySelector('.jm-cluster.jm-action-buttons') ||
      widget.querySelector('.jm-review-widget-minimal-header__action-buttons') ||
      widget.querySelector('.jm-action-buttons') ||
      widget.querySelector('.jm-review-widget-minimal-header__button-and-filters')
    );
    if (!bar) return;
    list.dataset.zxNav = '1';

    function mk(dir, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zx-rev-nav zx-rev-nav--' + dir;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      bar.appendChild(b);
      return b;
    }
    var prev = mk('prev', 'Onceki yorumlar', '\u2039');
    var next = mk('next', 'Sonraki yorumlar', '\u203A');

    function step() {
      var c = list.querySelector('.jm-review-item');
      return c ? c.getBoundingClientRect().width + 16 : 330;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left:  step(), behavior: 'smooth' }); });

    var pending = false;
    function sync() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var max = list.scrollWidth - list.clientWidth - 2;
        // Kaydiracak yer yoksa (genis ekranda hepsi sigiyorsa) oklari hic gosterme
        var need = list.scrollWidth > list.clientWidth + 4;
        var d = need ? 'inline-flex' : 'none';
        if (prev.style.display !== d) prev.style.display = d;
        if (next.style.display !== d) next.style.display = d;
        prev.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft >= max;
      });
    }
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function scan() {
    var l = document.querySelector('.jdgm-review-list:not([data-zx-nav])');
    if (l) build(l);
  }

  // Gozlemci YOK — sabit araliklarla birkac kez dene, sonra birak.
  var tries = 0;
  var iv = setInterval(function () {
    scan();
    if (++tries > 20 || document.querySelector('.jdgm-review-list[data-zx-nav]')) clearInterval(iv);
  }, 600);
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
})();
